import FormSubmit from "./FormSubmit";
import AddTeam from "./AddTeam";
import { v4 as uuidv4 } from "uuid";
import { removeAndAddListeners } from "../general/BuddyFuncs";

export default class AgribexForm {
  constructor(
    params = {
      formSelector: "",
      teamMembersHolderSelector: "",
      invitedInputsHolderSelector: "",
      removeBtnSelector: "",
      addTeamOptions: {},
    }
  ) {
    this.formSelector = params.formSelector;
    this.formClass = null;

    this.teamMembersHolderSelector = params.teamMembersHolderSelector;
    this.teamMembersHolder = null;

    this.invitedInputsHolderSelector = params.invitedInputsHolderSelector;
    this.invitedInputsHolder = null;

    this.addTeamOptions = params.addTeamOptions;
    this.addTeam = null;

    this.removeBtnSelector = params.removeBtnSelector;
    this.removeBtns = null;
  }

  init() {
    this.formClass = new FormSubmit({
      form: this.formSelector,
      submitFunc: (e) => {
        this.handleSubmitForm(e);
      },
    });

    this.formClass.init();

    this.addTeam = new AddTeam({
      toAddFormClass: this,
      ...this.addTeamOptions,
    });

    this.addTeam.init();

    this.teamMembersHolder = document.querySelector(
      this.teamMembersHolderSelector
    );

    this.invitedInputsHolder = document.querySelector(
      this.invitedInputsHolderSelector
    );

    this.removeBtns = document.querySelectorAll(this.removeBtnSelector);

    this.removeBtns.forEach((btn) => {
      removeAndAddListeners(btn, "click", (e) =>
        this.handleRemoveTeamMember(e)
      );
    });
  }

  handleRemoveTeamMember(e) {
    e.preventDefault();
    const index = e.currentTarget.dataset.index;

    this.deleteTeamMember(index);
  }

  deleteTeamMember(index) {
    //delete the article
    const currentArticle = document.querySelector(
      `article[data-index="${index}"]`
    );

    if (currentArticle) {
      currentArticle.outerHTML = "";
    }

    //delete inputs
    const invitedInput = document.querySelector(
      `.invitedInput[data-index="${index}"]`
    );

    if (invitedInput) {
      invitedInput.outerHTML = "";
    }
  }

  addTeamMember(member) {
    //update index
    member.index = uuidv4();

    //add to the dom
    this.addTeamMemberToForm(member);
  }

  updateTeamMember(member) {
    //update the article
    const currentArticle = document.querySelector(
      `article[data-index="${member.index}"]`
    );

    if (currentArticle) {
      currentArticle.outerHTML = this.teamMemberHtml(member);

      //add listeners
      this.addTeam.addListenersToTheButtons();
    }

    //update inputs
    const invitedInput = document.querySelector(
      `.invitedInput[data-index="${member.index}"]`
    );

    if (invitedInput) {
      invitedInput.outerHTML = this.invitedInputHtml(member);
    }
  }

  teamMemberHtml(member) {
    return `
    <article class="teamMember card" data-index="${member.index}">
      <div class="title">
          <h4>${member.firstNameInvite} ${member.lastNameInvite}</h4>
          <p>${member.emailInvite}</p>
      </div>
      <div class="adjustmentBtns">
          <button class="roundBtn ghost closeIcon removeTeamMember" data-index="${member.index}">
              <span class="hide">verwijder</span>
          </button>
          <button class="roundBtn editIcon editTeamMember" data-index="${member.index}">
              <span class="hide">pas aan</span>
          </button>
      </div>
    </article>`;
  }

  invitedInputHtml(member) {
    //create the inputs
    let inputs = "";

    Object.keys(member).forEach((key) => {
      if (key !== "index") {
        inputs += `<input name="${key}[]" type="hidden" value="${member[key]}">`;
      }
    });

    return `<div class="invitedInput" data-index="${member.index}">
              ${inputs}
            </div>`;
  }

  addTeamMemberToForm(member) {
    if (this.teamMembersHolder) {
      this.teamMembersHolder.innerHTML += this.teamMemberHtml(member);

      //add listeners
      this.addTeam.addListenersToTheButtons();

      this.removeBtns = document.querySelectorAll(this.removeBtnSelector);

      this.removeBtns.forEach((btn) => {
        removeAndAddListeners(btn, "click", (e) =>
          this.handleRemoveTeamMember(e)
        );
      });

      //add new inputs
      if (this.invitedInputsHolder) {
        this.invitedInputsHolder.innerHTML += this.invitedInputHtml(member);
      }
    }
  }

  handleSubmitForm(e) {
    //redirect to thanks page
    window.location.href = e.redirect;
  }
}
